<template>
  <v-card elevation="16">
    <v-container fluid>
      <v-layout row wrap>
        <v-flex class="flex-container-space-between" xs12>
          <h1 class="title grey--text text--darken-1">
            <v-icon class="mr-1">{{$store.state.global.pages.allocation.icon}}</v-icon>Allocation Entry
          </h1>
        </v-flex>
        <prelimAllocation></prelimAllocation>
        <v-flex xs12>
          <v-data-table
            :headers="headers"
            :items="allocations"
            item-key="timeEntered"
            class="elevation-1"
            hide-actions
            :disable-initial-sort="true"
          >
            <template slot="no-data">
              <div
                class="text-xs-center grey--text subheading"
              >Please enter allocation details above.</div>
            </template>

            <template slot="items" slot-scope="props">
              <prelim-allocation-row :allocation="props.item"></prelim-allocation-row>
            </template>
          </v-data-table>
        </v-flex>
      </v-layout>
    </v-container>
  </v-card>
</template>

<script>
import Store from "@/store/computed/storeHelpers";
import PrelimAllocation from "./prelimAllocation";
import PrelimAllocationRow from "./prelimAllocationRow";

export default {
  data() {
    return {
      selected: [],
      breaksDialog: false,
      rateDialog: false,
      headers: [
        { text: "Tip", value: "tip.name", sortable: false, align: "left" },
        { text: "Spoil", value: "spoil.name", sortable: false, align: "left" },
        {
          text: "Sub-Contractor",
          value: "contractor.name",
          sortable: false,
          align: "left"
        },
        {
          text: "Vehicle",
          value: "vehicle.name",
          sortable: false,
          align: "left"
        },
        {
          text: "Driver",
          value: "vehicle.name",
          sortable: false,
          align: "left"
        },
        {
          text: "Start Time",
          value: "startTime",
          sortable: false,
          align: "left"
        },
        { text: "Actions", align: "center", sortable: false }
      ]
    };
  },
  methods: {
    deleteAllocation(allocation) {
      this.$store.commit("batchAllocations/deleteFromArrayStateByValue", {
        prop: "allocations",
        value: allocation
      });
    }
  },
  computed: {
    allocations() {
      return this.$store.state.batchAllocations.allocations;
    }
  },
  components: {
    PrelimAllocation,
    PrelimAllocationRow
  }
};
</script>

<style scoped>
.trip-list-animate-item {
  transition: all 0.3s;
  max-height: 400px;
  margin-right: 10px;
  width: 100%;
}
.trip-list-animate-enter, .trip-list-animate-leave-to
        /* .trip-list-animate-leave-active below version 2.1.8 */ {
  max-height: 0px;
  opacity: 0;
  transform: translateX(-200px);
}
.trip-list-animate-leave-active {
  position: absolute;
}
</style>
